import React,{Fragment} from 'react';
/**Routing */
import{BrowserRouter as Router,Route,Switch} from "react-router-dom";
import Header from './header/Header';
import Inicio from './home/Inicio';


function App() {
  return (
    <Router>
    <Fragment>
   
 <Header/>

{/* rutas */}
  <Switch>
  <Route exact path="/" component={Inicio} />
  </Switch>

    </Fragment>
    </Router>
  );
}

export default App;
